module.exports = __webpack_public_path__ + "img/4.3b5c832d.png";